import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Calendar } from "lucide-react";

function isoToday() {
  return new Date().toISOString().slice(0, 10);
}

function isoDaysAgo(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

function isoMonthStart() {
  const d = new Date();
  d.setDate(1);
  return d.toISOString().slice(0, 10);
}

function isoYearStart() {
  return `${new Date().getFullYear()}-01-01`;
}

const PRESETS = [
  { label: "Hoy", from: () => isoToday(), to: () => isoToday() },
  { label: "7 días", from: () => isoDaysAgo(6), to: () => isoToday() },
  { label: "30 días", from: () => isoDaysAgo(29), to: () => isoToday() },
  { label: "90 días", from: () => isoDaysAgo(89), to: () => isoToday() },
  { label: "Mes actual", from: () => isoMonthStart(), to: () => isoToday() },
  { label: "Año actual", from: () => isoYearStart(), to: () => isoToday() },
];

export default function DateRangeFilter({ value, onChange, testidPrefix = "date-filter" }) {
  const setPreset = (preset) => {
    onChange({ date_from: preset.from(), date_to: preset.to() });
  };
  return (
    <div className="bg-card border border-border rounded-md p-3 mb-4 flex flex-wrap items-end gap-3" data-testid={`${testidPrefix}-container`}>
      <div className="flex items-center gap-2 mr-1">
        <Calendar className="w-4 h-4 text-muted-foreground" />
        <span className="overline">Periodo</span>
      </div>
      <div>
        <Label className="overline text-[10px]">Desde</Label>
        <Input
          type="date"
          value={value.date_from || ""}
          onChange={(e) => onChange({ ...value, date_from: e.target.value })}
          className="mt-1 h-9 font-mono w-40"
          data-testid={`${testidPrefix}-from`}
        />
      </div>
      <div>
        <Label className="overline text-[10px]">Hasta</Label>
        <Input
          type="date"
          value={value.date_to || ""}
          onChange={(e) => onChange({ ...value, date_to: e.target.value })}
          className="mt-1 h-9 font-mono w-40"
          data-testid={`${testidPrefix}-to`}
        />
      </div>
      <div className="flex flex-wrap gap-1 ml-auto">
        {PRESETS.map((p) => (
          <Button
            key={p.label}
            type="button"
            size="sm"
            variant="outline"
            className="text-xs h-9"
            onClick={() => setPreset(p)}
            data-testid={`${testidPrefix}-preset-${p.label.replace(/\s/g, "-").toLowerCase()}`}
          >
            {p.label}
          </Button>
        ))}
      </div>
    </div>
  );
}

export function defaultRange30() {
  return { date_from: isoDaysAgo(29), date_to: isoToday() };
}
export function defaultRange90() {
  return { date_from: isoDaysAgo(89), date_to: isoToday() };
}
export function defaultRangeMonth() {
  return { date_from: isoMonthStart(), date_to: isoToday() };
}
export function buildQuery(range) {
  const params = new URLSearchParams();
  if (range.date_from) params.set("date_from", range.date_from);
  if (range.date_to) params.set("date_to", range.date_to);
  return params.toString() ? `?${params.toString()}` : "";
}
